import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Typography } from '../Typography';
import styles from './Toast.module.scss';
const iconContent = {
    success: /*#__PURE__*/ _jsx("path", {
        d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2V2ZM16.3 9.61L11.73 15.61C11.5412 15.8552 11.2495 15.9993 10.94 16C10.6322 16.0017 10.3408 15.8615 10.15 15.62L7.71 12.51C7.37035 12.0737 7.4487 11.4447 7.885 11.105C8.32131 10.7653 8.95034 10.8437 9.29 11.28L10.92 13.36L14.7 8.36C15.0369 7.91817 15.6682 7.83311 16.11 8.17C16.5518 8.50689 16.6369 9.13817 16.3 9.58V9.61Z"
    }),
    error: /*#__PURE__*/ _jsx("path", {
        d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2V2ZM14.71 13.29C15.1021 13.6789 15.1047 14.3121 14.7158 14.7042C14.7139 14.7061 14.7119 14.7081 14.71 14.71C14.3211 15.1021 13.6879 15.1047 13.2958 14.7158C13.2939 14.7139 13.2919 14.7119 13.29 14.71L12 13.41L10.71 14.71C10.3211 15.1021 9.68792 15.1047 9.2958 14.7158C9.29386 14.7139 9.29193 14.7119 9.29 14.71C8.89788 14.3211 8.89529 13.6879 9.28421 13.2958C9.28613 13.2939 9.28806 13.2919 9.29 13.29L10.59 12L9.29 10.71C8.89788 10.3179 8.89788 9.68212 9.29 9.29C9.68213 8.89788 10.3179 8.89788 10.71 9.29L12 10.59L13.29 9.29C13.6821 8.89788 14.3179 8.89788 14.71 9.29C15.1021 9.68212 15.1021 10.3179 14.71 10.71L13.41 12L14.71 13.29Z"
    }),
    warning: /*#__PURE__*/ _jsx("path", {
        d: "M22.5591 16.3L14.8891 3.58V3.58C13.8688 1.9839 11.7479 1.5171 10.1517 2.53738C9.73273 2.80522 9.37697 3.16098 9.10912 3.58L1.43912 16.3H1.43912C0.88767 17.2192 0.868609 18.3629 1.38912 19.3C1.9911 20.3551 3.11435 21.0046 4.32912 21H19.6691C20.8756 21.0129 21.997 20.3797 22.6091 19.34V19.34C23.1452 18.3926 23.1261 17.2292 22.5591 16.3ZM11.9991 17C11.4468 17 10.9991 16.5523 10.9991 16C10.9991 15.4477 11.4468 15 11.9991 15C12.5514 15 12.9991 15.4477 12.9991 16C12.9991 16.5523 12.5514 17 11.9991 17ZM12.9991 13C12.9991 13.5523 12.5514 14 11.9991 14C11.4468 14 10.9991 13.5523 10.9991 13V9C10.9991 8.44771 11.4468 8 11.9991 8C12.5514 8 12.9991 8.44771 12.9991 9V13Z"
    }),
    info: /*#__PURE__*/ _jsx("path", {
        d: "M2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5229 17.5229 22 12 22C6.47715 22 2 17.5229 2 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12ZM12.7071 7.29289C13.0976 7.68341 13.0976 8.31658 12.7071 8.7071C12.3166 9.09762 11.6834 9.09762 11.2929 8.7071C10.9024 8.31658 10.9024 7.68341 11.2929 7.29289C11.6834 6.90237 12.3166 6.90237 12.7071 7.29289ZM11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V11Z"
    })
};
const typeToSkin = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'primary'
};
export function Toast(props) {
    const { type, text, testId, isMobileDevice = false } = props;
    const variant = isMobileDevice ? 'paragraph2' : 'paragraph1';
    return /*#__PURE__*/ _jsxs(Typography, {
        variant: variant,
        noWrap: !isMobileDevice,
        className: cn(styles.toast, styles[type]),
        testId: testId,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                skin: typeToSkin[type],
                children: /*#__PURE__*/ _jsx("svg", {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "currentColor",
                    children: iconContent[type]
                })
            }),
            text
        ]
    });
}
